import { t, useLanguage, getLocale } from "@/i18n/LanguageContext";import { useEffect, useState } from "react";
import { Inbox, Mail, Phone } from "lucide-react";
import { api } from "@/lib/api";

export default function MessagesTab({ onAuthError }) {useLanguage();
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    api.get("/admin/messages").
    then(({ data }) => setMessages(data)).
    catch((e) => {
      if (e.response?.status === 401) onAuthError();else
      setMessages([]);
    });
  }, [onAuthError]);

  if (messages === null) {
    return <p className="py-10 text-center text-sm text-slate-500">{t("Caricamento messaggi…")}</p>;
  }

  if (messages.length === 0) {
    return (
      <div className="flex flex-col items-center rounded-2xl border border-dashed border-slate-300 bg-white py-16" data-testid="messages-empty">
        <Inbox className="h-10 w-10 text-slate-300" />
        <p className="mt-4 text-sm text-slate-500">{t("Nessun messaggio ricevuto dal modulo contatti.")}</p>
      </div>);

  }

  return (
    <div className="space-y-4" data-testid="messages-list">
      {t(messages.map((m) =>
      <div key={m.id} data-testid={`message-${m.id}`} className="rounded-2xl border border-slate-200 bg-white p-6">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <h3 className="font-display font-bold text-brand-navydeep">{t(m.name)}</h3>
            <span className="font-mono text-[10px] uppercase tracking-wider text-slate-400">
              {t(new Date(m.created_at).toLocaleString(getLocale()))}
            </span>
          </div>
          <p className="mt-1 flex flex-wrap gap-4 text-xs text-slate-500">
            <span className="inline-flex items-center gap-1"><Mail className="h-3.5 w-3.5" />{t(m.email)}</span>
            {t(m.phone && <span className="inline-flex items-center gap-1"><Phone className="h-3.5 w-3.5" />{t(m.phone)}</span>)}
          </p>
          <p className="mt-3 rounded-xl bg-slate-50 p-4 text-sm leading-relaxed text-slate-700">{t(m.message)}</p>
        </div>
      ))}
    </div>);

}
